export default __webpack_public_path__ + "static/404.03a7d7c43333731bf6a355d90e4c550d.svg";